import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconSearch from "@arco-design/web-react/icon/react-icon/IconSearch";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconLeft from "@arco-design/web-react/icon/react-icon/IconLeft";
import React, { useState, useMemo, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { qaData, allTags, searchQA } from '../qaData';
import styles from '../style/index.module.less';
export default function QA() {
  const history = useHistory();
  const [query, setQuery] = useState('');
  const [activeTags, setActiveTags] = useState([]);
  const debounceRef = useRef();
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const handleQueryChange = useCallback(value => {
    setQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setDebouncedQuery(value);
    }, 300);
  }, []);
  const toggleTag = tag => {
    setActiveTags(prev => prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]);
  };
  const filteredItems = useMemo(() => {
    let items = qaData;
    // 标签筛选
    if (activeTags.length > 0) {
      items = items.filter(item => activeTags.some(tag => item.tags.includes(tag)));
    }
    // 搜索
    if (debouncedQuery.trim()) {
      return searchQA(debouncedQuery, items);
    }
    return items;
  }, [debouncedQuery, activeTags]);

  /** 高亮匹配关键词 */
  const highlightText = (text, keywords) => {
    if (!keywords.length) return text;
    let result = text;
    keywords.forEach(kw => {
      if (!kw) return;
      const regex = new RegExp(`(${kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      result = result.replace(regex, `<span class="${styles['qa-highlight']}">$1</span>`);
    });
    return result;
  };
  const searchKeywords = debouncedQuery.trim() ? debouncedQuery.trim().split(/\s+/).filter(Boolean) : [];
  return /*#__PURE__*/React.createElement("div", {
    className: styles['qa-page']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    icon: /*#__PURE__*/React.createElement(_IconLeft, null),
    onClick: () => history.push('/help')
  }, "\u8FD4\u56DE\u5E2E\u52A9\u4E2D\u5FC3")), /*#__PURE__*/React.createElement("h1", {
    className: styles['qa-page-title']
  }, "\u95EE\u7B54\u4E2D\u5FC3"), /*#__PURE__*/React.createElement("div", {
    className: styles['qa-search']
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconSearch, null),
    placeholder: "\u641C\u7D22\u4F60\u9047\u5230\u7684\u95EE\u9898...",
    allowClear: true,
    size: "large",
    value: query,
    onChange: handleQueryChange
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['qa-tags']
  }, allTags.map(tag => /*#__PURE__*/React.createElement("span", {
    key: tag,
    className: `${styles['qa-tag']} ${activeTags.includes(tag) ? styles['qa-tag-active'] : ''}`,
    onClick: () => toggleTag(tag)
  }, tag))), filteredItems.length > 0 ? filteredItems.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.id,
    className: styles['qa-result-item'],
    onClick: () => history.push(item.link)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['qa-result-question'],
    dangerouslySetInnerHTML: {
      __html: highlightText(item.question, searchKeywords)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['qa-result-summary'],
    dangerouslySetInnerHTML: {
      __html: highlightText(item.summary, searchKeywords)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['qa-result-meta']
  }, item.module, " \xB7 ", item.tags.join(' / ')))) : /*#__PURE__*/React.createElement("div", {
    className: styles['qa-empty']
  }, "\u6CA1\u6709\u627E\u5230\u76F8\u5173\u5185\u5BB9\uFF0C\u8BD5\u8BD5\u5176\u4ED6\u5173\u952E\u8BCD"));
}